import React from 'react';
import { Icon } from '@frontend/icons';
import { Text } from '../../text';
import { ActionPressedChip } from '../atoms';
import { flexCenter } from '../common-styles';

type BoldActionProps = Omit<React.ComponentProps<typeof ActionPressedChip>, 'children'>;

export const BoldAction = ({ compact = true, showBoxShadow = true, ...rest }: BoldActionProps) => {
  return (
    <ActionPressedChip {...rest} compact={compact} showBoxShadow={showBoxShadow}>
      <Text as='strong' weight='bold' className={flexCenter}>
        <Icon name='bold-small' />
      </Text>
    </ActionPressedChip>
  );
};
